module.exports = __webpack_public_path__ + "img/58_2.dfd8ec70.png";